@if (notification(); as note) {
  <!--
    Zur Positionierung siehe zwei Fallstricke des App-Layouts:

    1. Abstand zu Header und Footer. Beide liegen in einem Nachbar-Stacking-Context
       (.app-content ist `relative z-1`, .app-header/.app-footer sind `z-10`). Dadurch kann
       KEIN z-Index innerhalb des Planungsassistenten über sie hinweg — eine Meldung zu weit
       oben oder unten verschwände einfach dahinter. Deshalb 72px unter der Oberkante
       (Header 64px) bzw. 32px über der Unterkante (Footer ca. 24px).
    2. z-[1500] statt z-50, damit die Meldung über dem Planungsassistenten liegt: dessen
       Container geht im Vollbild auf `z-index: 1000 !important` (common_styles.scss).

    Sehr lange Meldungen (z. B. eine Warnung je Ticket) werden scrollbar statt aus dem Bild zu
    wachsen.
  -->
  <div
    class="fixed left-1/2 -translate-x-1/2 z-[1500] w-full max-w-3xl px-4 pointer-events-none"
    [ngClass]="note.position === 'top' ? 'top-[72px]' : 'bottom-8'"
  >
    <!--
      Mehrere Knöpfe kommen unter den Text, sonst drängen sie ihn zusammen und die Meldung läuft
      seitlich aus dem Fenster. Bei einem einzigen „Ok" — der Normalfall — bleibt es einzeilig,
      sonst verschenkte jede kurze Erfolgsmeldung eine Zeile.
    -->
    <div
      class="bm-alert bm-alert-soft shadow-lg pointer-events-auto items-start max-h-[70vh] overflow-y-auto"
      [class.bm-alert-vertical]="note.actions.length > 1"
      [class.items-stretch]="note.actions.length > 1"
      [class.bm-alert-error]="note.type === 'error'"
      [class.bm-alert-success]="note.type === 'success'"
      [class.bm-alert-info]="note.type === 'info'"
    >
      <span class="flex-1 whitespace-pre-line break-words">{{ note.message }}</span>
      @if (note.actions.length) {
        <div class="flex flex-row flex-wrap gap-2 justify-end shrink-0">
          @for (action of note.actions; track action.label) {
            <button class="bm-btn bm-btn-sm bm-btn-ghost" (click)="runAction(action)">{{ action.label }}</button>
          }
        </div>
      }
    </div>
  </div>
}
